class FaqList extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['control', 'answer']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.handleClick.bind(this))
  }

  handleClick (event) {
    const controlEl = event.target.closest(this.els?.control?.selector)
    if (!controlEl) return

    const isExpanded = controlEl.getAttribute('aria-expanded') === 'true'
    controlEl.setAttribute('aria-expanded', !isExpanded)

    const answerEl = this.els?.answer?.elements?.find(
      answerEl => answerEl.id === controlEl.getAttribute('aria-controls'),
    )
    if (!answerEl) return

    answerEl.style.maxHeight = isExpanded ? null : `${answerEl.scrollHeight}px`
  }
}

if (!customElements.get('faq-list')) {
  customElements.define('faq-list', FaqList)
}
